import React, { useState, useEffect } from "react";
import "./WorkerInfoModal.css";
import { Copy, RotateCw, X, Eye } from "lucide-react";
import { useTranslation } from "react-i18next";
import { db } from "../firebase";
import { doc, updateDoc } from "firebase/firestore";

function WorkerInfoModal({ worker, onClose }) {
  const { t } = useTranslation();
  const [displayCode, setDisplayCode] = useState(worker?.loginCode || "");
  const [isUsed, setIsUsed] = useState(worker?.codeUsed || false);

  useEffect(() => {
    setDisplayCode(worker?.loginCode || "");
    setIsUsed(worker?.codeUsed || false);
  }, [worker]);

  if (!worker) return null;

  const copyCode = () => {
    if (displayCode) {
      navigator.clipboard.writeText(displayCode);
      alert(t("code_copied") || "Kodas nukopijuotas!");
    }
  };

  const handleRegenerate = async () => {
    // Pataisytas confirm pranešimas su vertimu
    if (!window.confirm(t("confirm_regenerate_code") || "Ar tikrai norite sugeneruoti naują kodą?")) return;
    
    const newCode = Math.floor(100000 + Math.random() * 900000).toString();
    try {
      const workerRef = doc(db, "workers", worker.id);
      await updateDoc(workerRef, { loginCode: newCode, codeUsed: false });
      setDisplayCode(newCode);
      setIsUsed(false);
    } catch (e) { 
      alert(t("error") + ": " + e.message);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box info" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-flex">
          {/* Pakeista į vertimą */}
          <h2 className="modal-title">{t("worker_info").toUpperCase()}</h2>
          <button className="close-x" onClick={onClose}><X size={20} /></button>
        </div>

        {/* PAGRINDINĖ INFORMACIJA */}
        <div className="info-section">
          <div className="info-field">
            <label>{t("name").toUpperCase()}</label>
            <div className="info-val">{worker.name}</div>
          </div>
          <div className="info-field">
            <label>E-MAIL</label>
            <div className="info-val">{worker.email || "-"}</div>
          </div>
          <div className="info-field">
            <label>{t("phone").toUpperCase()}</label>
            <div className="info-val">{worker.phone || "-"}</div>
          </div>
        </div>

        {/* ZUGANGSCODE KORTELĖ */}
        <div className="access-code-wrapper">
          <div className="code-content">
            <span className="code-label">{t("login_code")}</span>
            <strong className="code-text">{displayCode || "—"}</strong>
            <div className="code-btns">
              <button onClick={copyCode} className="icon-btn-small" title={t("copy")}><Copy size={16} /></button>
              <button onClick={handleRegenerate} className="icon-btn-small reset" title={t("regenerate")}><RotateCw size={16} /></button>
              <div className={`status-dot ${isUsed ? 'used' : 'active'}`}></div>
            </div>
          </div>
          <div className="code-status-label">{isUsed ? t("codeUsed") : t("codeActive")}</div>
        </div>

        {/* PAPILDOMI LAUKAI */}
        {worker.customFields && worker.customFields.length > 0 && (
          <div className="info-section">
            {worker.customFields.map((field, idx) => (
              <div className="info-field" key={idx}>
                <label>{field.label.toUpperCase()}</label>
                <div className="info-val">{field.value || "-"}</div>
              </div>
            ))}
          </div>
        )}

        {/* DOKUMENTAI */}
        <h3 className="docs-title">{t("documents")}</h3>
        <div className="docs-scroll-area">
          {(!worker.documents || worker.documents.length === 0) ? (
            <p className="no-docs">{t("no_documents")}</p>
          ) : (
            worker.documents.map((doc, index) => (
              <div className="doc-row" key={index}>
                <span className="doc-name">{doc.name}</span>
                <div className="doc-actions">
                  <button 
                    className="doc-btn-round dl" 
                    onClick={() => window.open(doc.url, '_blank')}
                    title={t("view") || "Peržiūrėti"}
                  >
                    <Eye size={18} />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        <button className="cancel-btn full" onClick={onClose}>{t("close")}</button>
      </div>
    </div>
  );
}

export default WorkerInfoModal;